// src/CurrencyContext/CurrencyContext.js
import React, { createContext, useContext, useState, useEffect } from "react";

const CurrencyContext = createContext();

export const CurrencyProvider = ({ children }) => {
  const [currency, setCurrency] = useState("INR");
  const [conversionRates, setConversionRates] = useState({ INR: 1, USD: 1, EUR: 1 });
  const [loading, setLoading] = useState(false);

  const currencySymbols = {
    INR: "₹",
    USD: "$",
    EUR: "€",
  };

  const fetchLiveRates = async () => {
    setLoading(true);
    try {
       const response = await fetch(
  "https://api.exchangerate-api.com/v4/latest/INR"
);

if (!response.ok) {
  throw new Error(`HTTP error! status: ${response.status}`);
}

const data = await response.json();

if (data?.rates) {
  setConversionRates({
    INR: 1,
    USD: data.rates.USD,
    EUR: data.rates.EUR,
  });

  localStorage.setItem(
    "conversionRates",
    JSON.stringify({
      INR: 1,
      USD: data.rates.USD,
      EUR: data.rates.EUR,
    })
  );
}
    } catch (error) {
      console.error("Error fetching live currency rates:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const savedRates = JSON.parse(localStorage.getItem("conversionRates"));
    if (savedRates) setConversionRates(savedRates);
    fetchLiveRates();
    const interval = setInterval(fetchLiveRates, 6 * 60 * 60 * 1000); // every 6 hours
    return () => clearInterval(interval);
  }, []);

  const changeCurrency = (newCurrency) => {
  setCurrency(newCurrency);
};


  return (
    <CurrencyContext.Provider
      value={{ currency, changeCurrency, conversionRates, currencySymbols, loading }}
    >
      {children}
    </CurrencyContext.Provider>
  );
};

export const useCurrency = () => useContext(CurrencyContext);
